import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-block q-px-xl row justify-between items-center" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-block__logo row justify-center items-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toIndex && _ctx.toIndex(...args)))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "sidebar__image-wrapper" }, null, -1)
    ])),
    _createElementVNode("div", {
      class: "header-block__button row justify-center items-center font-header-4 cursor-pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toIndex && _ctx.toIndex(...args)))
    }, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Перейти в ИС"))
        : (_openBlock(), _createBlock(_component_q_spinner_dots, { key: 1 }))
    ])
  ]))
}